// =============================================================================
// app/src/componentes/Ordenacao.tsx — o seletor de ORDEM das telas de lista.
//
// POR QUE <select> E NÃO BOTÕES (como o Segmentado): ordem é uma escolha entre
// cinco ou seis opções com rótulo comprido ("Maior valor", "Prazo mais curto"),
// e seis botões nessa largura quebram em três linhas no celular e empurram a
// lista para fora da tela. Filtro é toggle e cabe em botão; ordem é lista e
// cabe em menu. Foi o desenho que a tela de Estoque já tinha acertado.
//
// A ordem é sempre EXPLÍCITA no rótulo ("Mais recente", "Maior valor") em vez
// de campo + seta: no balcão ninguém traduz "data ↓" para "a mais nova em
// cima" — e traduzir errado é ler a lista errada.
// =============================================================================

export interface OpcaoDeOrdem<T extends string> {
  id: T;
  rotulo: string;
}

export default function Ordenacao<T extends string>({ opcoes, valor, aoMudar, id }: {
  opcoes: ReadonlyArray<OpcaoDeOrdem<T>>;
  valor: T;
  aoMudar: (id: T) => void;
  id?: string;
}) {
  return (
    <label className="flex items-center gap-2 text-sm">
      <span className="shrink-0 text-dim">Ordenar</span>
      <select
        id={id}
        className="campo py-1"
        value={valor}
        onChange={(e) => aoMudar(e.target.value as T)}
      >
        {opcoes.map((o) => (
          <option key={o.id} value={o.id}>{o.rotulo}</option>
        ))}
      </select>
    </label>
  );
}
